import React from "react";
import wifi from '../../../assets/wifi.png';
import {motion} from 'framer-motion'

const Connect = ({data}) => {
  return (
    <>
      {/* Desktop Layout */}
      <div className="relative my-20 md:block hidden">
        <div className="w-[90%] mx-auto">
          <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#183864] via-[#1e4a73] to-[#2563eb] shadow-2xl">
            {/* Background Image */}
            <div className="absolute inset-0">
              <img 
                src={data.image} 
                alt="Connect Background" 
                className="w-full h-full object-cover opacity-30"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#183864]/90 via-[#183864]/70 to-transparent"></div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-48 translate-x-48"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#B02526]/20 rounded-full translate-y-32 -translate-x-32"></div>
            
            {/* Content */}
            <div className="relative z-10 px-12 py-16 lg:px-16 lg:py-20">
              <div className="max-w-2xl">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  className="flex items-center gap-4 mb-6"
                >
                  <div className="text-white">
                    <h2 className="font-bold text-4xl lg:text-5xl xl:text-6xl leading-tight">
                      {data.heading || "Connect"}
                    </h2>
                  </div>
                  <motion.div
                    animate={{ rotate: 360 }}
                    transition={{ duration: 20, repeat: Infinity, ease: "linear" }}
                  >
                    <img src={wifi} alt="wifi" className="w-16 h-16 lg:w-20 lg:h-20" />
                  </motion.div>
                </motion.div>
                
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.2 }}
                  className="text-white/90 text-lg lg:text-xl leading-relaxed mb-8"
                >
                  {data.tagLine || "Stay connected with us for the latest updates and opportunities"}
                </motion.p>
                
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 }}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <button className="bg-gradient-to-r from-[#B02526] to-[#d63031] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-300 hover:shadow-lg hover:shadow-[#B02526]/25 transform hover:scale-105">
                    {data.button_text || "Get Started"}
                  </button>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Layout */}
      <div className="my-8 md:hidden block">
        <div className="w-[90%] mx-auto">
          <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#183864] to-[#2563eb] shadow-xl">
            {/* Background Image */}
            <div className="absolute inset-0">
              <img 
                src={data.image} 
                alt="Connect Background" 
                className="w-full h-full object-cover opacity-30"
              />
              <div className="absolute inset-0 bg-[#183864]/80"></div>
            </div>
            
            {/* Content */}
            <div className="relative z-10 px-6 py-8">
              <div className="flex items-center gap-3 mb-4">
                <h2 className="text-white font-bold text-xl">
                  {data.heading || "Connect"}
                </h2>
                <img src={wifi} alt="wifi" className="w-8 h-8" />
              </div>
              
              <p className="text-white/90 text-sm leading-relaxed mb-6">
                {data.tagLine || "Stay connected with us"}
              </p>
              
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <button className="bg-gradient-to-r from-[#B02526] to-[#d63031] text-white px-6 py-3 rounded-full font-semibold text-sm transition-all duration-300 hover:shadow-lg">
                  {data.button_text || "Get Started"}
                </button>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Connect;
